import React from 'react'
import styled from 'styled-components'

const GradientContainer = styled.div<{ gradient: string }>`
  background: ${(props) => props.gradient};
  width: 140px;
  min-width: 140px;
  height: 140px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  width: 130px;
  height: 130px;
  background-color: white;
  color: black;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  && h1 {
    font-size: 75px;
    margin: 0;
  }

  && h5 {
    margin: 0;
    font-size: 25px;
  }

  && h2 {
    margin-bottom: 0;
    line-height: 1;
    font-size: 36px;
  }
`

export const RatingCard = styled.div`
  width: 100%;
  display: flex;
`

export const RatingCardContent = styled.div`
  padding-left: 25px;
  flex-grow: 1;

  && ul {
    padding-left: 20px;
  }
`

export const RatingLevel = styled.h5`
  && {
    margin-top: 0;
  }
`

export const RatingSmallerHeader = styled.h1`
  && {
    font-size: 65px;
  }
`

export const RatingEmailLink = styled.a`
  border-bottom: none;
  font-weight: bold;
`

export const RatingDivider = styled.div`
  margin-top: 65px;
  margin-bottom: 35px;
  height: 1px;
  background-color: #d8d8d8;
`

type RatingSquareProps = {
  gradient: string
}

export const RatingSquare: React.FC<RatingSquareProps> = ({ gradient, children }) => (
  <GradientContainer gradient={gradient}>
    <Content>{children}</Content>
  </GradientContainer>
)
